export const IS_STATE_RESTORATION_FROM_DOM_ENABLED = true;

export function getTrackingObj(value) {
  return value ? JSON.parse(value) : null;
}

export function getLinkColor(link) {
  if (!link) {
    return '';
  }

  const styleAttr = link.getAttribute('style');

  if (!styleAttr) {
    return '';
  }

  const hexColorMatch = styleAttr.match(/color:\s?(#[a-z0-9]{3,6})/i);

  if (hexColorMatch) {
    return hexColorMatch[1];
  }

  const rgbMatch = styleAttr.match(/color:\s?rgb\((\d+),\s?(\d+),\s?(\d+)\)/);

  if (!rgbMatch) {
    return '';
  }

  // convert rgb to hex
  return rgbMatch.reduce((acc, cur, index) => {
    if (index === 0) {
      return acc;
    }

    return acc + Number(cur).toString(16);
  }, '#');
}

export function getLinkObj(link) {
  if (!link) {
    return {
      id: undefined,
      text: '',
      url: '',
      tracking: null,
    };
  }

  const { id, tracking, url: dataUrl, text } = link.dataset;
  const url = link.getAttribute('href') || dataUrl || '';

  return {
    url,
    id: id || link.id,
    text: text || link.textContent || '',
    tracking: url ? getTrackingObj(tracking) : null,
  };
}

export function getMobileTopMenuWithGroups() {
  const topMenu = {};
  const categoryNodes = document.getElementsByClassName('l1-categories-group');

  Array.from(categoryNodes).forEach((group) => {
    const linkNodes = group.querySelectorAll('.l1-categories a,.l1-categories button');

    Array.from(linkNodes).forEach((cur) => {
      const data = getLinkObj(cur);
      const fontColor = getLinkColor(cur);
      topMenu[data.id] = {
        ...data,
        children: [],
        isCatSplash: Boolean(cur.dataset.catSplash),
        ...(fontColor ? { fontColor } : {}),
      };
    }, {});
  });

  return topMenu;
}

export function getMobileDeepMenu(topMenu = {}) {
  return Array.from(document.querySelectorAll('.sub-categories')).reduce((acc, subCategory) => {
    const { id, text, url, tracking, parent: parentId, catSplash: isCatSplash } = subCategory.dataset;
    const fontColor = getLinkColor(subCategory);
    const links = subCategory.querySelectorAll('li a,li button');

    if (id === 'LOYALLIST') {
      return acc;
    }

    const itemData = {
      id,
      text,
      url,
      ...(parentId ? { parentId } : {}),
      ...(fontColor ? { fontColor } : {}),
      isCatSplash: Boolean(isCatSplash),
      tracking: getTrackingObj(tracking),
      children: Array.from(links).reduce((childrenAcc, cur) => {
        if (!cur.dataset.skip) {
          childrenAcc.push({ ...getLinkObj(cur), isCatSplash: Boolean(cur.dataset.catSplash) });
        }
        return childrenAcc;
      }, []),
    };

    acc[id] = {
      ...(topMenu[id] || {}),
      ...itemData,
    };

    return acc;
  }, {});
}

export function restoreMobileMenu() {
  const topMenu = getMobileTopMenuWithGroups();
  return { ...topMenu, ...getMobileDeepMenu(topMenu) };
}

export function parseDesktopTopLevel() {
  const root = document.getElementById('nav-top-menu');
  return Array.from(root.children).reduce((acc, li) => {
    const link = li.querySelector('.fob-item a');

    if (link) {
      const color = getLinkColor(link);
      acc.push({
        ...getLinkObj(link),
        // parse text from data-text attr instead of textContent property as adobe TnT scripts can change source text
        text: link.dataset.text,
        color,
      });
    }

    return acc;
  }, []);
}

export function parseDesktopFobLevel(text) {
  const root = document.querySelector(`[data-testid="flyout-${text}"]`);

  if (!root) {
    return [];
  }

  const columns = root.getElementsByClassName('category-cell');

  return Array.from(columns).map((col) =>
    Array.from(col.getElementsByClassName('category-group')).map((group) => {
      if (group.classList.contains('flyout-image-wrapper')) {
        const image = group.querySelector('img');
        const linkUnderImage = group.querySelector('.menu-link-heavy');
        const imageLink = group.querySelector('.image-link');
        const underImageLink = group.querySelector('.under-image-link');

        return {
          isImage: true,
          src: image.dataset.src,
          imageLink: group.querySelector('.image-link').getAttribute('href'),
          text: linkUnderImage?.textContent || '',
          url: linkUnderImage?.getAttribute('href') || '',
          alt: image.alt || undefined,
          imageLinkTracking: getTrackingObj(imageLink?.dataset?.tracking),
          linkTracking: getTrackingObj(underImageLink?.dataset?.tracking),
        };
      }

      const headerLink = group.querySelector('.subcategory-header-link,h5');
      const headerLinkObj = getLinkObj(headerLink);
      return {
        ...headerLinkObj,
        color: getLinkColor(headerLink),
        id: group.dataset.id,
        children: Array.from(group.querySelectorAll('.menu-link-sm.link')).map((link) => ({
          ...getLinkObj(link),
          color: getLinkColor(link),
        })),
      };
    }),
  );
}

export function restoreDesktopMenu() {
  const desktopMenu = parseDesktopTopLevel();

  // parse flyouts
  desktopMenu.forEach((category) => {
    category.children = parseDesktopFobLevel(category.text);
  });

  return desktopMenu;
}

export function trackingObjToString(tracking, returnNullIfEmpty) {
  if (typeof tracking === 'object' && tracking !== null) {
    return JSON.stringify(tracking);
  }

  return returnNullIfEmpty ? null : undefined;
}

function getFooterColumnLinks() {
  const columns = document.querySelectorAll('#nav-footer-root .row-1 .footer-links-group');
  return Array.from(columns).map((column) => {
    const heading = column.querySelector('.links-header').textContent.trim();
    const contentlinks = Array.from(column.querySelectorAll('li a')).map((link) => ({
      text: link.textContent,
      value: link.getAttribute('href'),
      tracking: trackingObjToString(link.dataset.tracking, true),
    }));

    return { heading, contentlinks };
  });
}

function getFooterLegalLinks() {
  return Array.from(document.querySelectorAll('#nav-footer-root .row-2 li a')).map((link) => {
    const linkObj = {
      label: link.textContent,
      value: link.getAttribute('href'),
    };

    if (link.dataset.oneTrust) {
      linkObj.oneTrust = true;
    }

    return linkObj;
  });
}

export function restoreFooterLinks() {
  const footerLinks = getFooterColumnLinks();
  const legalLinks = getFooterLegalLinks();

  return { footerLinks, legalLinks };
}
